import { useCallback } from "react";
import { useRoadmap } from "@/context/RoadmapContext";

export function TaskRow({ taskId, label, tab, children, className = "", isRecruitment = false, accentClass = "" }) {
  const { getTaskStatus, saveTaskStatus } = useRoadmap();
  const status = getTaskStatus(taskId);
  const isP = status === "in-progress";
  const isD = status === "done";

  const rowCls = isRecruitment ? "recruitment-action-row" : "task-row";
  const wrapCls = isRecruitment
    ? `relative recruitment-deploy-card ${isP ? "task-in-progress" : ""} ${isD ? "task-done" : ""} ${className}`
    : `${rowCls} ${isP ? "task-in-progress" : ""} ${isD ? "task-done" : ""} ${className}`;

  const handleClick = useCallback((type) => {
    let newStatus;
    if (type === "progress") newStatus = isP ? "idle" : "in-progress";
    else newStatus = isD ? "idle" : "done";
    saveTaskStatus(taskId, label, tab, newStatus);
  }, [taskId, label, tab, isP, isD, saveTaskStatus]);

  if (isRecruitment) {
    return (
      <div className={wrapCls} data-task-id={taskId} data-testid={`task-${taskId}`}>
        {accentClass && <div className={`pointer-events-none absolute inset-y-0 left-0 w-1.5 rounded-l-lg ${accentClass}`} data-testid={`task-accent-${taskId}`} />}
        <div className="relative z-10">{children}</div>
        <div className="relative z-10 mt-4 flex justify-end gap-2">
          <BtnProgress active={isP} onClick={() => handleClick("progress")} />
          <BtnDone active={isD} onClick={() => handleClick("done")} />
        </div>
      </div>
    );
  }

  return (
    <div className={wrapCls} data-task-id={taskId} data-testid={`task-${taskId}`}>
      <div className="flex justify-between items-center w-full gap-4">
        <div className="task-text text-sm leading-tight w-full">{children}</div>
        <div className="flex gap-2 shrink-0 z-10 task-controls">
          <BtnProgress active={isP} onClick={() => handleClick("progress")} />
          <BtnDone active={isD} onClick={() => handleClick("done")} />
        </div>
      </div>
    </div>
  );
}

function BtnProgress({ active, onClick }) {
  return (
    <button onClick={onClick} className={`btn-progress p-[6px] rounded-md transition-colors border outline-none ${active ? "bg-[#4c7e55] dark:bg-[#2e6d3b] text-white border-[#4c7e55] dark:border-[#2e6d3b]" : "bg-gray-100 dark:bg-gray-800/50 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-500 border-gray-200 dark:border-gray-700"}`} data-testid="btn-progress">
      <svg className="w-4 h-4 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    </button>
  );
}

function BtnDone({ active, onClick }) {
  return (
    <button onClick={onClick} className={`btn-done p-[6px] rounded-md transition-colors border outline-none ${active ? "bg-green-500 text-white border-green-600" : "bg-gray-100 dark:bg-gray-800/50 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-500 border-gray-200 dark:border-gray-700"}`} data-testid="btn-done">
      <svg className="w-4 h-4 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
    </button>
  );
}
